(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('RiskRuleDialogController', RiskRuleDialogController);

    RiskRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RiskRule', 'Lender'];

    function RiskRuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RiskRule, Lender) {
        var vm = this;

        vm.riskRule = entity;
        vm.clear = clear;
        vm.save = save;
        vm.lenders = Lender.querySimplePublic();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.riskRule.id !== null) {
                RiskRule.update(vm.riskRule, onSaveSuccess, onSaveError);
            } else {
                RiskRule.save(vm.riskRule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:riskRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
